import { Language } from "./Language.component";

export { Language };
